import React from 'react';

export default function Mission() {
  return (
    <section id="mission" className="py-24 md:py-32 relative overflow-hidden" style={{background:'linear-gradient(135deg,#0A0A14,#0F1629,#0A0A14)'}}>
      <div className="grid-bg absolute inset-0 opacity-30" />
      <div className="orb w-96 h-96 -bottom-20 left-1/4 opacity-10" style={{background:'rgba(26,46,107,0.8)'}} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16 reveal">
          <span className="section-tag">Our Purpose</span>
          <h2 className="font-playfair font-black text-white" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(2rem,3.5vw,3rem)'}}>
            Mission & <span style={{color:'#C8A84B'}}>Vision</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          {/* Mission */}
          <div className="reveal-left p-10 rounded-sm relative overflow-hidden group"
            style={{background:'rgba(255,255,255,0.03)',border:'1px solid rgba(200,168,75,0.12)'}}>
            <div className="absolute top-0 left-0 w-full h-[3px] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500"
              style={{background:'linear-gradient(90deg,#C8A84B,#F0D080)'}} />
            <div className="absolute top-6 right-8 text-8xl font-black opacity-5" style={{fontFamily:'Playfair Display,serif',color:'#C8A84B'}}>M</div>

            <h3 className="font-playfair font-black text-white text-2xl mb-6 relative z-10" style={{fontFamily:'Playfair Display,serif'}}>
              Our <span style={{color:'#C8A84B'}}>Mission</span>
            </h3>
            <p className="leading-relaxed mb-4 relative z-10" style={{color:'rgba(212,207,197,0.7)',fontSize:'0.92rem'}}>
              At ITS Academy, our mission is to <strong className="text-white">empower students and professionals with high-quality, industry-oriented computer education</strong>. We are committed to providing practical knowledge, hands-on training, and skill development that prepare learners for real-world challenges.
            </p>
            <ul className="space-y-3 mb-6 relative z-10">
              {[
                'Deliver job-ready skills for students and working professionals',
                'Promote digital literacy across all age groups',
                'Foster innovation and creativity in technology education',
                'Maintain a supportive and professional learning environment',
                'Equip learners with confidence to excel in competitive industries',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-sm" style={{color:'rgba(212,207,197,0.65)'}}>
                  <span style={{color:'#C8A84B',flexShrink:0,marginTop:'2px'}}>✦</span>
                  {item}
                </li>
              ))}
            </ul>
            <div className="relative z-10 p-4 rounded-sm border-l-4" style={{borderLeftColor:'#C8A84B',background:'rgba(200,168,75,0.05)',color:'rgba(240,208,128,0.85)',fontSize:'0.88rem',fontStyle:'italic',lineHeight:'1.7'}}>
              "Empowering every student with practical skills to succeed in the digital world."
            </div>
          </div>

          {/* Vision */}
          <div className="reveal-right p-10 rounded-sm relative overflow-hidden group"
            style={{background:'rgba(255,255,255,0.03)',border:'1px solid rgba(200,168,75,0.12)'}}>
            <div className="absolute top-0 left-0 w-full h-[3px] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500"
              style={{background:'linear-gradient(90deg,#C8A84B,#F0D080)'}} />
            <div className="absolute top-6 right-8 text-8xl font-black opacity-5" style={{fontFamily:'Playfair Display,serif',color:'#C8A84B'}}>V</div>

            <h3 className="font-playfair font-black text-white text-2xl mb-6 relative z-10" style={{fontFamily:'Playfair Display,serif'}}>
              Our <span style={{color:'#C8A84B'}}>Vision</span>
            </h3>
            <p className="leading-relaxed mb-4 relative z-10" style={{color:'rgba(212,207,197,0.7)',fontSize:'0.92rem'}}>
              Our vision is to become <strong className="text-white">the leading computer education institute in Saharanpur and beyond</strong>, recognized for excellence in teaching, professional training, and innovative learning solutions.
            </p>
            <ul className="space-y-3 mb-6 relative z-10">
              {[
                'Create digitally skilled professionals who thrive in IT & finance',
                'Establish ITS Academy as a benchmark of quality and integrity',
                'Provide state-of-the-art infrastructure and experienced faculty',
                'Continuously adapt to emerging technologies and industry trends',
                'Cultivate lifelong learning, ethical practice and social responsibility',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-sm" style={{color:'rgba(212,207,197,0.65)'}}>
                  <span style={{color:'#C8A84B',flexShrink:0,marginTop:'2px'}}>✦</span>
                  {item}
                </li>
              ))}
            </ul>
            <div className="relative z-10 p-4 rounded-sm border-l-4" style={{borderLeftColor:'#C8A84B',background:'rgba(200,168,75,0.05)',color:'rgba(240,208,128,0.85)',fontSize:'0.88rem',fontStyle:'italic',lineHeight:'1.7'}}>
              "To be the first choice for aspirants seeking practical, professional, and future-ready computer education."
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
